function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M19.41 21.75H4.59c-.26 0-.51-.14-.64-.36L.77 16.1a.74.74 0 010-.76L8.18 2.63c.13-.23.38-.37.65-.37h6.35c.27 0 .51.14.65.37 2.79 4.78 7 11.99 7.36 12.55.1.13.15.28.15.45 0 .18-.06.34-.17.47-.26.39-2.02 3.42-3.11 5.28-.13.23-.38.37-.65.37zm-14.4-1.5h13.97c1.49-2.56 2.29-3.92 2.78-4.64-.57-.84-1.57-2.54-3.54-5.91l-3.47-5.95H9.26L2.29 15.7l2.72 4.55z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.41 21.75c-.26 0-.51-.13-.65-.37l-10.59-18a.752.752 0 111.3-.76l10.59 18a.752.752 0 01-.65 1.13z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.59 21.75a.752.752 0 01-.65-1.13l10.59-18a.752.752 0 111.3.76l-10.59 18a.77.77 0 01-.65.37z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22 16.46H1.5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75H22c.41 0 .75.34.75.75s-.34.75-.75.75z"
})));